import { useServices } from '@/components/ServiceContext';
import React from 'react';
import GenericReportPage from '@/pages/Reports/GenericReportPage';
import { reportDefinitions } from '@lambda-layer/constants/reportDefinitions';

const ListNameExpirationCountReport: React.FC = () => {
  const { boughtListService } = useServices();

  const report = reportDefinitions.find(
    rd => rd.id === 'report-bl-list-name-expiration-count'
  );

  return (
    report && (
      <GenericReportPage
        listType="boughtlist"
        listService={boughtListService}
        filterDefinitions={report.filterDefinitions}
        exportReportName={report.exportName}
      />
    )
  );
};

export default ListNameExpirationCountReport;
